import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";

import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";

import "./assets/dist/css/bootstrap.css";
import "./assets/css/style.css";
import "./assets/css/rfs.css";
import * as myConstClass from "./constant.js";
import { cartHasProducts, cartHasMagazines, cartHasRegularEvents, cartHasMachineTests } from "./constant.js";
import { clearGuestStatesOnLogin } from "./utils/guestStateManager.js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import NewHeader from "./newHeader.js";
import Footer from "./Footer.js";
import facebook_sign_in from "./assets/images/facebook_sign_in.png";
import google_sign_in from "./assets/images/google_sign_in.png";
import $ from "jquery";
import SimpleReactValidator from "simple-react-validator";
import GoogleLogin from "react-google-login";
//import FacebookLogin from 'react-facebook-login';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
//import TiSocialFacebookCircular from 'react-icons/lib/ti/social-facebook-circular';

// Translation Higher Order Component
import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage,
  getLanguage,
  translate,
} from "react-switch-lang";
import en from "./en.json";
import ma from "./ma.json";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventinfo: {
        user_id: "",
        first_name: "",
        last_name: "",
        middle_name: "",
        email: "",
        mobile: "",
      },
      guestinfo: {
        email: "",
        password: "",
      },
      showPassword: false,
      flag: 0,
      google_link: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGoogleClick = this.handleGoogleClick.bind(this);
    this.handleContinueWithoutLogin = this.handleContinueWithoutLogin.bind(this);
    this.transferGuestCartToUser = this.transferGuestCartToUser.bind(this);
    this.validator = new SimpleReactValidator();
  }

  notify = () => toast("Wow so easy !");
  componentDidMount() {
    var message = localStorage.getItem("success");
    if (message != "" && message != null) {
      toast("" + message, { containerId: "B", type: toast.TYPE.SUCCESS });

      localStorage.removeItem("success");
    }
    
    var error = localStorage.getItem("error");
    if (error != "" && error != null) {
      toast("" + error, { containerId: "B", type: toast.TYPE.ERROR });
      localStorage.removeItem("error");
    }
    // get Google Link URL
    fetch(myConstClass.BASE_URL + "users/GetGoogleLoginURL/")
      .then((response) => response.json())
      .then((response) => this.setState({ google_link: response.google_link }));

    //       fetch(myConstClass.BASE_URL+'product/getAvailProdTypes')
    //       .then(response => response.json())
    //       .then(response =>this.setState({types: response}))
    //       .catch(err => console.log(err))

    //       const answer_array = this.props.location.pathname.split('/');
    //        // alert(answer_array);
    //     if(answer_array['2']){

    //   fetch(myConstClass.BASE_URL+'product/getProductInfo/'+answer_array['2']+'/'+getLanguage())
    //   .then(response => response.json())
    //   .then(response =>this.setState({guestinfo: response}))
    //   .catch(err => console.log(err))

    //   fetch(myConstClass.BASE_URL+'product/getRelatedProducts/'+answer_array['2'])
    //       .then(response => response.json())
    //       .then(response =>this.setState({posts: response}))
    //       .catch(err => console.log(err))

    //     }
  }

  componentDidUpdate(prevProps) {
    const answer_array = this.props.location.pathname.split("/");
    const { flag } = this.state;

    // alert(answer_array);
    //    if(answer_array['2'] && getLanguage()=='ma' && flag==0){
    //     this.setState({flag:1})
    //  fetch(myConstClass.BASE_URL+'product/getProductInfo/'+answer_array['2']+'/'+getLanguage())
    //  .then(response => response.json())
    //  .then(response =>this.setState({guestinfo: response}))
    //  .catch(err => console.log(err))
    //    }

    //    if(answer_array['2'] && getLanguage()=='en' && (flag==1)){
    //     this.setState({flag:0})
    //  fetch(myConstClass.BASE_URL+'product/getProductInfo/'+answer_array['2']+'/'+getLanguage())
    //  .then(response => response.json())
    //  .then(response =>this.setState({guestinfo: response}))
    //  .catch(err => console.log(err))
    //    }
  }

  async handleGoogleClick(e) {
    //Code for recaptcha added on 31.03.23 SGH
    e.preventDefault();

    // const token = await window.grecaptcha.execute(
    //   "6LdMWkElAAAAADiLK_36r8e9ZzJPLOoz1mSWVo-J"
    // );

    //console.log("Token is "+token);

    // if (!token) {
    //   alert("Please verify that you are not a robot.");
    //   return;
    // }

    //Rest of the Code follows 31.03.23 SGH

    fetch(myConstClass.BASE_URL + "users/googleLogin/");
    //.then(response => response.json())
    //.then(response =>this.setState({guestinfo: response}))
    //.catch(err => console.log(err))

    // Reset the reCAPTCHA widget
    // if (typeof window.grecaptcha !== "undefined") {
    //   window.grecaptcha.reset();
    // }
  }

  handleContinueWithoutLogin(e) {
    e.preventDefault();
    // Set flag to remember user's choice to continue as guest
    localStorage.setItem('continue_as_guest', 'true');
    // Also set guest_allowed so pages that check this flag (e.g. Mycart) permit guest access
    localStorage.setItem('guest_allowed', 'true');
    // Prevent any previously scheduled signin redirects from firing
    try {
      localStorage.setItem('cancel_pending_redirects', 'true');
      const pendingId = localStorage.getItem('pending_signin_redirect_timeout_id');
      if (pendingId) {
        clearTimeout(Number(pendingId));
        localStorage.removeItem('pending_signin_redirect_timeout_id');
      }
    } catch (err) {
      // ignore
    }
    // Clear any error messages
    localStorage.removeItem('error');
    
    // Redirect back to the page where user was adding items to cart
    const redirectPath = localStorage.getItem('redirect_after_login');
    if (redirectPath) {
      localStorage.removeItem('redirect_after_login');
      toast('Continue shopping as guest. You can sign in anytime from the header!', { 
        containerId: 'B', 
        type: toast.TYPE.INFO 
      });
      this.props.history.push(redirectPath);
    } else {
      // If no redirect path, go to homepage
      this.props.history.push('/');
    }
  }

  // Transfer guest cart items to logged-in user's account
  async transferGuestCartToUser(user_id) {
    try {
      const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
      const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
      const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
      const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
      
      // If no guest cart items, nothing to transfer
      if (guestProducts.length === 0 && guestMagazines.length === 0 && guestEvents.length === 0 && guestMachineTests.length === 0) {
        return true;
      }

      // Check what the logged-in user already has in their database cart
      const [userHasProducts, userHasMagazines, userHasRegularEvents, userHasMachineTests] = await Promise.all([
        cartHasProducts(user_id),
        cartHasMagazines(user_id),
        cartHasRegularEvents(user_id),
        cartHasMachineTests(user_id)
      ]);

      // guestEvents contains only regular events; machine tests are in separate guestMachineTests
      const guestRegularEvents = guestEvents;
      
      // Check for conflicts between guest cart and user's existing cart
      let hasConflict = false;
      let conflictMessage = '';
      
      // If guest has products but user has magazines or events (products can coexist with machine tests)
      if (guestProducts.length > 0 && (userHasMagazines || userHasRegularEvents)) {
        hasConflict = true;
        const items = [];
        if (userHasMagazines) items.push(getLanguage() === 'en' ? 'magazines' : 'मासिके');
        if (userHasRegularEvents) items.push(getLanguage() === 'en' ? 'events' : 'कार्यक्रम');
        const itemsText = items.join(getLanguage() === 'en' ? ' and ' : ' आणि ');
        conflictMessage = getLanguage() === 'en'
          ? `Your account already has ${itemsText} in cart. Please checkout or clear your cart before adding products.`
          : `तुमच्या खात्यात आधीच ${itemsText} कार्टमध्ये आहेत. उत्पादने जोडण्यापूर्वी कृपया चेकआउट करा किंवा कार्ट साफ करा.`;
      }
      
      // If guest has magazines but user has products, events, or machine tests (magazines conflict with all)
      if (guestMagazines.length > 0 && (userHasProducts || userHasRegularEvents || userHasMachineTests)) {
        hasConflict = true;
        const items = [];
        if (userHasProducts) items.push(getLanguage() === 'en' ? 'products' : 'उत्पादने');
        if (userHasRegularEvents) items.push(getLanguage() === 'en' ? 'events' : 'कार्यक्रम');
        if (userHasMachineTests) items.push(getLanguage() === 'en' ? 'machine tests' : 'मशीन चाचण्या');
        const itemsText = items.join(getLanguage() === 'en' ? ' and ' : ' आणि ');
        conflictMessage = getLanguage() === 'en'
          ? `Your account already has ${itemsText} in cart. Please checkout or clear your cart before adding magazines.`
          : `तुमच्या खात्यात आधीच ${itemsText} कार्टमध्ये आहेत. मासिके जोडण्यापूर्वी कृपया चेकआउट करा किंवा कार्ट साफ करा.`;
      }
      
      // If guest has regular events but user has products, magazines, or machine tests (events conflict with all)
      if (guestRegularEvents.length > 0 && (userHasProducts || userHasMagazines || userHasMachineTests)) {
        hasConflict = true;
        const items = [];
        if (userHasProducts) items.push(getLanguage() === 'en' ? 'products' : 'उत्पादने');
        if (userHasMagazines) items.push(getLanguage() === 'en' ? 'magazines' : 'मासिके');
        if (userHasMachineTests) items.push(getLanguage() === 'en' ? 'machine tests' : 'मशीन चाचण्या');
        const itemsText = items.join(getLanguage() === 'en' ? ' and ' : ' आणि ');
        conflictMessage = getLanguage() === 'en'
          ? `Your account already has ${itemsText} in cart. Please checkout or clear your cart before adding events.`
          : `तुमच्या खात्यात आधीच ${itemsText} कार्टमध्ये आहेत. कार्यक्रम जोडण्यापूर्वी कृपया चेकआउट करा किंवा कार्ट साफ करा.`;
      }
      
      // If guest has machine tests but user has magazines or regular events (machine tests can coexist with products)
      if (guestMachineTests.length > 0 && (userHasMagazines || userHasRegularEvents)) {
        hasConflict = true;
        const items = [];
        if (userHasMagazines) items.push(getLanguage() === 'en' ? 'magazines' : 'मासिके');
        if (userHasRegularEvents) items.push(getLanguage() === 'en' ? 'events' : 'कार्यक्रम');
        const itemsText = items.join(getLanguage() === 'en' ? ' and ' : ' आणि ');
        conflictMessage = getLanguage() === 'en'
          ? `Your account already has ${itemsText} in cart. Please checkout or clear your cart before adding machine tests.`
          : `तुमच्या खात्यात आधीच ${itemsText} कार्टमध्ये आहेत. मशीन चाचण्या जोडण्यापूर्वी कृपया चेकआउट करा किंवा कार्ट साफ करा.`;
      }

      // If conflict exists, save warning to show on cart page and DON'T transfer
      if (hasConflict) {
        // Save conflict message to localStorage to show on cart page after redirect
        localStorage.setItem('cart_conflict_message', conflictMessage);
        // Keep guest cart in localStorage - don't clear it
        return false;
      }

      // No conflict - proceed with transfer
      
      // Transfer products
      if (guestProducts.length > 0) {
        for (const product of guestProducts) {
          try {
            await fetch(
              myConstClass.BASE_URL + `cart/addProductToCart/${product.product_id}/${product.quantity}/${user_id}`,
              { method: 'GET' }
            );
          } catch (err) {
          }
        }
      }
      
      // Transfer magazines
      if (guestMagazines.length > 0) {
        for (const magazine of guestMagazines) {
          try {
            await fetch(
              myConstClass.BASE_URL + `cart/addMagazineToCart/${magazine.package_id}/${user_id}`,
              { method: 'GET' }
            );
          } catch (err) {
          }
        }
      }
      
      // Transfer regular events
      if (guestEvents.length > 0) {
        for (const event of guestEvents) {
          try {
            await fetch(
              myConstClass.BASE_URL + `cart/addEventToCart/${event.schedule_id}/${user_id}/${event.parent}/${event.child || 0}`,
              { method: 'GET' }
            );
          } catch (err) {
          }
        }
      }
      
      // Transfer machine tests
      if (guestMachineTests.length > 0) {
        for (const machineTest of guestMachineTests) {
          try {
            await fetch(
              myConstClass.BASE_URL + `cart/addMachineTestEventToCart/${machineTest.event_id}/${user_id}/${machineTest.parent || 1}/${machineTest.child || 0}`,
              { method: 'GET' }
            );
          } catch (err) {
          }
        }
      }
      
      // Clear guest cart from localStorage after successful transfer
      localStorage.removeItem('guest_cart_products');
      localStorage.removeItem('guest_cart_magazines');
      localStorage.removeItem('guest_cart_events');
      localStorage.removeItem('guest_mt_cart');
      
      return true;
    } catch (error) {
      return false;
    }
  }
  
  async handleSubmit(e) {
    e.preventDefault();
    
    // // Execute reCAPTCHA v3 Enterprise
    // if (!window.grecaptcha || !window.grecaptcha.enterprise) {
    //   console.error('reCAPTCHA not loaded:', {
    //     grecaptcha: !!window.grecaptcha,
    //     enterprise: window.grecaptcha ? !!window.grecaptcha.enterprise : false
    //   });
    //   toast('reCAPTCHA is not loaded yet. Please refresh the page.', { 
    //     containerId: 'B', 
    //     type: toast.TYPE.ERROR 
    //   });
    //   return;
    // }

    $("#btn_click").css("display", "none");
    $("#loader").css("display", "inline");
    
    try {
      // Get reCAPTCHA token
      // await window.grecaptcha.enterprise.ready(async () => {
      //   console.log('reCAPTCHA ready, executing...');
      //   const token = await window.grecaptcha.enterprise.execute('6LervOgrAAAAAJN4JTdfI_4MJmiDKRRVap4qBzT7', {action: 'LOGIN'});
        
      //   console.log('reCAPTCHA token received:', token ? 'YES (length: ' + token.length + ')' : 'NO');
        
      //   if (!token) {
      //     console.error('No reCAPTCHA token received');
      //     toast('reCAPTCHA verification failed. Please try again.', { 
      //       containerId: 'B', 
      //       type: toast.TYPE.ERROR 
      //     });
      //     $("#btn_click").css("display", "inline");
      //     $("#loader").css("display", "none");
      //     return;
      //   }

        if (this.validator.allValid()) {
      // e.preventDefault();
      // console.log('this.refs', $('#pform').serializeArray());
      const formData = {};
      for (const field in this.refs) {
        formData[field] = this.refs[field].value;
      }
      // console.log("-->", formData);
      // console.log("deploy success"); myConstClass.BASE_URL
      
      const loginData = {
        email: this.state.guestinfo.email,
        password: this.state.guestinfo.password,
        //recaptcha_token: token  // Send token to backend
      };
      
      fetch(myConstClass.AUTH_API + '/login', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginData)
      })
        .then((response) => response.json())
        .then(async (response) => {
          this.setState({ eventinfo: response });
          //console.log('this.state.eventinfo.user_id',this.state.eventinfo.user_details.user_id)
          //localStorage.setItem('user_id');
          var status = this.state.eventinfo.status;
          var message = this.state.eventinfo.message;
          if (status == "true") {
            $("#btn_click").css("display", "inline");
            $("#loader").css("display", "none");
            var user_id = this.state.eventinfo.user_details.user_id;
            var first_name = this.state.eventinfo.user_details.first_name;
            var middle_name = this.state.eventinfo.user_details.middle_name;
            var last_name = this.state.eventinfo.user_details.last_name;
            var email = this.state.eventinfo.user_details.email;
            var profile_picture =
              this.state.eventinfo.user_details.profile_picture;
            var is_verify_sadhak_no =
              this.state.eventinfo.user_details.is_verify_sadhak_no;
            var access_token =
              this.state.eventinfo.access_token ||
              this.state.eventinfo.user_details.access_token ||
              "";

            localStorage.setItem("user_id", user_id);
            localStorage.setItem("first_name", first_name);
            localStorage.setItem("middle_name", middle_name);
            localStorage.setItem("last_name", last_name);
            localStorage.setItem("email", email);
            localStorage.setItem("success", message);
            localStorage.setItem("profile_picture", profile_picture);
            localStorage.setItem("is_verify_sadhak_no", is_verify_sadhak_no);
            localStorage.setItem("user_access_token", access_token);
            toast("" + message, { containerId: "B", type: toast.TYPE.SUCCESS });
            
            // Transfer guest cart items to user's account
            await this.transferGuestCartToUser(user_id);
            
            // Clear guest states now that user is logged in
            // This preserves event booking flow if one is in progress
            clearGuestStatesOnLogin();
            
            // Check if user needs to be redirected back to a specific page
            const redirectPath = localStorage.getItem('redirect_after_login');
            if (redirectPath) {
              localStorage.removeItem('redirect_after_login');
              setTimeout(() => this.props.history.push(redirectPath), 1000);
            } else {
              setTimeout(() => this.props.history.push('/'), 1000);
            }
            // document.cookie = "auth_cookie=1; path=/";
          } else {
            $("#btn_click").css("display", "inline");
            $("#loader").css("display", "none");
            toast(message, { containerId: "B", type: toast.TYPE.ERROR });
            //toast("Wow so easy !");
          }
        })
        //.then(toast('User Added Successfully..!', {containerId: 'B',type: toast.TYPE.SUCCESS}),setTimeout(this.props.history.push('signin'),100))
        .catch((error) => {
          $("#btn_click").css("display", "inline");
          $("#loader").css("display", "none");
        });
    } else {
      $("#btn_click").css("display", "inline");
      $("#loader").css("display", "none");
      //alert('here');
      this.validator.showMessages();
      // e.preventDefault();
      toast("Please fill all required fields.", {
        containerId: "B",
        type: toast.TYPE.ERROR,
      });
      // toast('Please fill all required fields.', {containerId: 'B',type: toast.TYPE.ERROR})
    }
  } catch (error) {
      // console.error('reCAPTCHA error:', error);
      // $("#btn_click").css("display", "inline");
      // $("#loader").css("display", "none");
      // toast('reCAPTCHA verification failed. Please try again.', { 
      //   containerId: 'B', 
      //   type: toast.TYPE.ERROR 
      // });
    }
  }
 

  async signup(res, type) {
    let postData;
    if (type === "facebook" && res.id) {
      postData = {
        name: res.name,
        provider: type,
        email: res.email,
        provider_id: res.id,
        token: res.accessToken,
        //  provider_pic: res.picture.data.url
      };
    }
    //if (type === 'google'){
    if (type === "google" && res.profileObj.googleId) { 
      postData = {
        name: res.profileObj.name,
        provider: type,
        email: res.profileObj.email,
        provider_id: res.profileObj.googleId,
      };
    }

    if (postData) {
      //alert(JSON.stringify(postData));
      fetch(myConstClass.BASE_URL + `users/socialLoginUser/`, {
        method: "POST",
        body: JSON.stringify(postData),
      })
        .then((response) => response.json())
        .then(async (response) => {
          this.setState({ eventinfo: response });
          var status = this.state.eventinfo.status;
          var message = this.state.eventinfo.message;
          if (status == "true") {
            var user_id = this.state.eventinfo.user_details.user_id;
            var first_name = this.state.eventinfo.user_details.first_name;
            var middle_name = this.state.eventinfo.user_details.middle_name;
            var last_name = this.state.eventinfo.user_details.last_name;
            var email = this.state.eventinfo.user_details.email;
            var profile_picture =
              this.state.eventinfo.user_details.profile_picture;
            var is_verify_sadhak_no =
              this.state.eventinfo.user_details.is_verify_sadhak_no;
            var access_token =
              this.state.eventinfo.access_token ||
              this.state.eventinfo.user_details.access_token ||
              "";
            localStorage.setItem("user_id", user_id);
            localStorage.setItem("first_name", first_name);
            localStorage.setItem("middle_name", middle_name);
            localStorage.setItem("last_name", last_name);
            localStorage.setItem("email", email);
            localStorage.setItem("success", message);
            localStorage.setItem("profile_picture", profile_picture);
            localStorage.setItem("is_verify_sadhak_no", is_verify_sadhak_no);
            localStorage.setItem("user_access_token", access_token);
            toast("" + message, { containerId: "B", type: toast.TYPE.SUCCESS });
            
            // Transfer guest cart items to user's account
            await this.transferGuestCartToUser(user_id);
            
            // Clear guest states now that user is logged in
            // This preserves event booking flow if one is in progress
            clearGuestStatesOnLogin();
            
            // Check if user needs to be redirected back to a specific page
            const redirectPath = localStorage.getItem('redirect_after_login');
            if (redirectPath) {
              localStorage.removeItem('redirect_after_login');
              setTimeout(() => this.props.history.push(redirectPath), 1000);
            } else {
              setTimeout(() => this.props.history.push('/'), 1000);
            }
          } else {
            if (this.state.eventinfo.mstatus == "true") {
              //  alert('pop up');
              $("#fbModel").modal("show");
              $("#postData").val(JSON.stringify(postData));
            } else {
              toast(message, { containerId: "B", type: toast.TYPE.ERROR });
            }
          }
        });
    } else {
    }
  }

  componentWillUnmount() {
    if(!(localStorage.getItem('guest_allowed') === 'true')) {
      localStorage.removeItem('guest_cart_events');
    }
  }

  render() {
    const { location } = this.props;
    const isRegisterPage = location.pathname === "/signin";
    const PagePath2 = location.pathname;

    const responseFacebook = (response) => {
      this.signup(response, "facebook");
    };
    const responseGoogle = (response) => {
      this.signup(response, "google");
    };

    const { posts, guestinfo, toast } = this.state;
    const { t } = this.props;
    return (
      <>
        <div className="App">
          <div>
            <ToastContainer />
          </div>
          <NewHeader />

          {/*Start of Container*/}
          <div class="container-fluid my-5">
            <Row className="px-xl-5 px-lg-5 px-md-5 py-md-3 px-2 g-4">
              <Col xl="12" lg="12" md="12" sm="12" xs="12 g-5">
                <Form
                  action=""
                  id="pform"
                  onSubmit={this.handleSubmit}
                  method="post"
                  encType="multipart/form-data"
                  className="form-horizontal"
                >
                  {/*2 Column Login Layout*/}
                  <div class="row justify-content-center" style={{ gap: '5rem' }}>
                    {/*Column 1 - Google Login & Email/Password Login*/}
                    <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 mb-4" style={{  paddingRight: '2rem' }}>
                      {/* Google Login Section */}
                      <div class="text-center mb-4">
                        {/*  class="font-weight-bold text-dark mb-3">Click Below to Login with Gmail (Google)</h4> */}
                        <div class="d-flex justify-content-center">
                          <GoogleLogin
                            clientId="800455904093-eonvlc21ffngqlg3b2u7kguff1gtbpa1.apps.googleusercontent.com"
                            onSuccess={responseGoogle}
                            onFailure={responseGoogle}
                            render={(renderProps) => (
                              <button
                                onClick={renderProps.onClick}
                                disabled={renderProps.disabled}
                                style={{
                                  cursor: "pointer",
                                  border: "1px solid #dadce0",
                                  borderRadius: "4px",
                                  backgroundColor: "#fff",
                                  padding: "10px 20px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "100%",
                                  minHeight: "45px",
                                  fontSize: "16px",
                                  fontFamily: "Roboto, sans-serif",
                                  color: "#3c4043",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  transition: "box-shadow 0.3s ease"
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.2)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.15)";
                                }}
                              >
                                <img
                                  src="https://developers.google.com/identity/images/g-logo.png"
                                  alt="Google"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px"
                                  }}
                                />
                                Login with Google
                              </button>
                            )}
                          />
                        </div>
                      </div>

                      {/* OR Divider */}
                      <div class="text-center my-4">
                        <h4 class="font-weight-bold text-dark">OR</h4>
                      </div>

                      {/* Existing User Login Section */}
                      <div class="text-center mb-4">
                        <h4 class="font-weight-bold text-dark">Existing User ?</h4>
                      </div>
                        
                      <div class="form-group">
                        <label class="color-black font-weight-bolder">
                          {t("home.Registered Email ID")}
                        </label>
                        <input
                          onChange={(e) => {
                            this.setState({
                              guestinfo: {
                                ...guestinfo,
                                email: e.target.value,
                              },
                            });
                          }}
                          autoFocus
                          type="text"
                          class="form-control"
                          id="email"
                          name="email"
                          placeholder={t("home.Enter_email_ID")}
                          onBlur={() =>
                            this.validator.showMessageFor("email")
                          }
                        />
                        {this.validator.message(
                          "email",
                          this.state.guestinfo.email,
                          "required"
                        )}
                      </div>
                      
                      <div class="form-group">
                        <label class="color-black font-weight-bolder">
                          {t("home.Password")}
                        </label>
                        <div class="position-relative">
                          <input
                            type={this.state.showPassword ? "text" : "password"}
                            class="form-control"
                            id="password"
                            name="password"
                            placeholder={t("home.Enter password")}
                            onChange={(e) => {
                              this.setState({
                                guestinfo: {
                                  ...guestinfo,
                                  password: e.target.value,
                                },
                              });
                            }}
                            onBlur={() =>
                              this.validator.showMessageFor("password")
                            }
                            onCopy={(e) => e.preventDefault()}
                            onPaste={(e) => e.preventDefault()}
                          />
                          <button
                            type="button"
                            
                            style={{
                              position: "absolute",
                              right: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              background: "transparent",
                              border: "none",
                              padding: 0,
                              margin: 0,
                              cursor: "pointer",
                              color: "#9d0b0e",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                            onClick={() =>
                              this.setState({
                                showPassword: !this.state.showPassword,
                              })
                            }
                            tabIndex="-1"
                          >
                            {this.state.showPassword ? (
                              <i class="fas fa-eye-slash "></i>
                            ) : (
                              <i class="fas fa-eye"></i>
                            )}
                          </button>
                        </div>
                        {this.validator.message(
                          "password",
                          this.state.guestinfo.password,
                          "required"
                        )}
                        <div class="text-right mt-2">
                          <Link to="/forgot-password" class="small text-primary">
                            {t("home.Forgot Password?")}
                          </Link>
                        </div>
                      </div>
                      
                      <div class="text-center">
                        <button
                          id="btn_click"
                          name="btn_click"
                          class="btn btn-brown px-1 px-sm-4 px-md-4"
                          style={{  fontSize: '16px', width: '50%' }}
                        >
                          {t("home.Login")}
                        </button>
                        <img
                          style={{ display: "none" }}
                          id="loader"
                          name="loader"
                          src={myConstClass.IMAGE_URL + "loader.gif"}
                          class="img-fluid"
                          alt="Loading"
                        />
                      </div>
                    </div>
                    {/*End of Column 1*/}

                    {/*Column 2 - New user / Register / Continue without login*/}
                    <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 mb-4" style={{ paddingLeft: '2rem' }}>
                      {/* New User Section */}
                      <div class="text-left mb-4">
                        <h4 class="font-weight-bold text-dark">New User ?</h4>
                      </div>

                      {/* Benefits of Registration */}
                      <div class="mb-4">
                        <h5 class="text-left mb-3">Benefits of Registration:</h5>
                        <ul class="list-unstyled">
                          <li class="mb-2">• You can view Order History of all earlier Orders</li>
                          <li class="mb-2">• Your Shipping Address Information will be saved, so no need of entering it again</li>
                        </ul>
                      </div>

                      {/* Register Button */}
                      <div class="text-center mb-3">
                        <Link to="/signup" class="btn btn-brown px-1 px-sm-4 px-md-4" style={{  fontSize: '16px', width: '50%' }}>
                          Register
                        </Link>
                      </div>

                      {/* OR Divider */}
                      <div class="text-center ">
                        <h4 class="font-weight-bold text-dark d-sm-block d-lg-none d-md-none d-xl-none d-none">OR</h4>
                      </div>

                      {/* Continue without login */}
                      <div class="text-center">
                        <h4 class="font-weight-bold text-dark mb-3">OR</h4>
                        <button
                          type="button"
                          onClick={this.handleContinueWithoutLogin}
                          class="btn btn-brown px-1 px-sm-4 px-md-4"
                          style={{ fontSize: '16px', width: '100%', maxWidth: '250px' }}
                        >
                          Continue without Login
                        </button>
                      </div>

                    </div>
                    {/*End of Column 2*/}

                  </div>
                  {/*End of 2 Column Login Layout*/}
                </Form>
              </Col>
            </Row>
          </div>
          {/*End of Container*/}

          <Footer history={this.props.history} />
        </div>
        {/*End of App*/}
      </>
    );
  }
}
Signin.propTypes = {
  t: PropTypes.func.isRequired,
};
export default translate(Signin);
